<div class="card hca-member-warning-card" fxFlex *ngIf="tou?.termsOfUseText">
    <h3 class="card-title" style="text-align: center">Terms and conditions</h3>
    <span [innerHTML]="tou.termsOfUseText"></span>
    <div fxLayout="row" class="mgbt-medium" fxLayoutAlign="center">
      <button type="button" class="btn btn-primary" style="margin-right: 20px" (click)="submitTermsChange(submitTermsTrueValue)">Accept</button>
      <button type="button" class="btn" (click)="submitTermsChange(false)">Decline</button>
    </div>
</div>